var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url && _vm.url.length)?_c('a',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.image),expression:"image",arg:"background-image"}],attrs:{"href":_vm.url}}):_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.image),expression:"image",arg:"background-image"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/LazyImageBackground.vue